import {h, Fragment} from "preact"
const ProductCardSkeleton = () => {
    return (
      <a href="#" className="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-py-2 ns-my-2 ns-mx-0" aria-label="Loading product...">
        <div className="product-card-container">
          <div className="product-card product-item" tabindex="0">
            
            {/* Badge skeleton */}
            <span className="product-card__badge skeleton-shimmer">
              <div className="skeleton-box skeleton-badge"></div>
            </span>
  
            {/* Wishlist button skeleton */}
            <button className="pdp-wishlist__add skeleton-shimmer" aria-label="Loading wishlist">
              <div className="skeleton-box skeleton-heart"></div>
            </button>
  
            {/* Product image skeleton */}
            <div className="product-card__image">
              <div className="image">
                <div className="image__clearcut">
                  <div className="skeleton-shimmer skeleton-image"></div>
                </div>
                <div className="image__normal">
                  <div className="skeleton-shimmer skeleton-image"></div>
                </div>
              </div>
  
              {/* Quick buy skeleton */}
              <div className="product-card__quickbuy">
                <div className="card-quickbuy skeleton-shimmer">
                  <div className="card-quickbuy__static">
                    <div className="skeleton-box skeleton-quickbuy-text"></div>
                  </div>
                </div>
              </div>
            </div>
  
            {/* Product info skeleton */}
            <div className="product-card__info">
              <div className="product-card__row-info">
                {/* Brand skeleton */}
                <p className="product-brand">
                  <div className="skeleton-shimmer skeleton-box skeleton-brand"></div>
                </p>
                
                {/* Product name and price skeleton */}
                <h3 className="product-name">
                  <div className="skeleton-shimmer">
                    <div className="skeleton-box skeleton-name"></div>
                    <div className="skeleton-box skeleton-price"></div>
                  </div>
                </h3>
  
                {/* Color swatches skeleton */}
                <div className="product-card__swatches">
                  <div className="skeleton-swatch skeleton-shimmer"></div>
                  <div className="skeleton-swatch skeleton-shimmer"></div>
                  <div className="skeleton-swatch skeleton-shimmer"></div>
                  <div className="skeleton-swatch skeleton-shimmer"></div>
                  <div className="colors-list__more skeleton-shimmer">
                    <div className="skeleton-box skeleton-more-colors"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    );
  };
  
  const ProductSkeletonGrid = ({ count = 8 }) => {
    return (
      <div className="collection-wrapper">
        {/* Search results header skeleton */}
        <div className="search-results-header skeleton-shimmer" style={{ marginBottom: '2rem' }}>
          <div className="skeleton-box skeleton-results-text"></div>
        </div>
  
        {/* Filter section skeleton */}
        <div className="filter-section skeleton-shimmer" style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="skeleton-box skeleton-filter-text"></div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <div className="skeleton-box skeleton-view-option"></div>
            <div className="skeleton-box skeleton-view-option"></div>
          </div>
        </div>
        
        {/* Product grid */}
        <div 
          id="product-grid" 
          className="product-grid collection-product-grid__products collection-products--four-column-grid collection-products--two-column-grid"
        >
          {Array.from({ length: count }, (_, index) => (
            <ProductCardSkeleton key={index} />
          ))}
        </div>
        
        <style jsx>{`
          /* Shimmer animation */
          @keyframes shimmer {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
          
          .skeleton-shimmer {
            position: relative;
            overflow: hidden;
            background: #f0f0f0;
          }
          
          .skeleton-shimmer::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.6),
              transparent
            );
            animation: shimmer 1.5s infinite;
            z-index: 1;
          }
          
          .skeleton-box {
            background: #e0e0e0;
            border-radius: 4px;
          }
          
          /* Image skeleton */
          .skeleton-image {
            width: 100%;
            aspect-ratio: 4/5;
            background: #e0e0e0;
          }
          
          /* Badge skeleton */
          .skeleton-badge {
            width: 40px;
            height: 20px;
            position: absolute;
            top: 12px;
            left: 12px;
            z-index: 2;
          }
          
          /* Heart/wishlist skeleton */
          .skeleton-heart {
            width: 21px;
            height: 21px;
            border-radius: 50%;
            position: absolute;
            top: 12px;
            right: 12px;
            z-index: 2;
          }
          
          /* Quick buy skeleton */
          .skeleton-quickbuy-text {
            width: 80px;
            height: 16px;
            margin: 12px auto;
          }
          
          /* Brand skeleton */
          .skeleton-brand {
            width: 50px;
            height: 14px;
            margin-bottom: 4px;
          }
          
          /* Product name skeleton */
          .skeleton-name {
            width: 100%;
            height: 18px;
            margin-bottom: 8px;
          }
          
          /* Price skeleton */
          .skeleton-price {
            width: 60px;
            height: 18px;
          }
          
          /* Color swatch skeleton */
          .skeleton-swatch {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #e0e0e0;
            margin-right: 8px;
            display: inline-block;
          }
          
          .skeleton-more-colors {
            width: 30px;
            height: 20px;
            display: inline-block;
            margin-left: 8px;
          }
          
          /* Header skeletons */
          .skeleton-results-text {
            width: 200px;
            height: 32px;
          }
          
          .skeleton-filter-text {
            width: 80px;
            height: 20px;
          }
          
          .skeleton-view-option {
            width: 32px;
            height: 24px;
          }
          
          /* Product card spacing */
          .product-card-container {
            position: relative;
          }
          
          .product-card__swatches {
            display: flex;
            align-items: center;
            margin-top: 8px;
          }
          
          .product-card__info {
            padding-top: 16px;
          }
          
          .product-card__image {
            position: relative;
          }
          
          /* Responsive adjustments */
          @media (max-width: 767px) {
            .collection-products--four-column-grid .skeleton-name {
              font-size: 14px;
            }
            
            .collection-products--four-column-grid .skeleton-brand {
              width: 40px;
              height: 12px;
            }
          }
        `}</style>
      </div>
    );
  };
  
  export default ProductSkeletonGrid;